// React
import React, { useState, useEffect, useRef } from 'react';

// Components
import Wrapper from '../../detail/Wrapper/Wrapper';

// Contexts
import { DetailContext } from '../../../contexts/detail';

// Hooks
import useDetail from '../../../hooks/useDetail';
import useMounted from '../../../hooks/useMounted';

// Third party
import { useParams } from 'react-router-dom';

// Data types
import { trimCore, trimDetail } from '../../../data-types/trim';

// Shared
import eventBus from '../../../shared/eventBus';

// This component
export default function TrimDetail() {
  const { itemId } = useParams();
  const isNewItem = itemId === 'new';

  // Data types
  const { endpoint, getDetailId } = trimCore();
  const {
    baseUrl,
    getInputs,
    watchedParameters,
    generateDerivativeCode,
    generateFullDescription
  } = trimDetail();

  // Detail
  const { cultures, saveCulturesDataSource, saveCultures } = useDetail();

  // If the component is mounted
  const mounted = useMounted();

  const generateDerivativeCodeRef = useRef(generateDerivativeCode);
  const generateFullDescriptionRef = useRef(generateFullDescription);
  const watchedParametersRef = useRef(watchedParameters);

  const [generatedValues, setGeneratedValues] = useState({
    derivativeCode: null,
    fullDescription: null
  });

  useEffect(() => {
    for (let key in watchedParametersRef.current) {
      eventBus.on(`formInputChange_${key}`, (data_) => {
        if (
          mounted.current &&
          watchedParametersRef.current.hasOwnProperty(data_.parameter)
        ) {
          watchedParametersRef.current[key] = data_;
          
          // b/c steering ID is a hidden input
          // we cannot use the onchange event 
          // to keep track of the value so instead we will
          // just get the value from the page
          // (TODO: maybe there is a better way??)
          watchedParametersRef.current['steeringId'] = { value : document.getElementsByName('steeringId')[0].value };

          const derivativeCode = generateDerivativeCodeRef.current(
            watchedParametersRef.current['modelId'],
            watchedParametersRef.current['engineId'],
            watchedParametersRef.current['salesVersionId'],
            watchedParametersRef.current['gearboxId'],
            watchedParametersRef.current['steeringId'],
            watchedParametersRef.current['countryId']
          );

          const fullDescription = generateFullDescriptionRef.current(
            watchedParametersRef.current['modelId'],
            watchedParametersRef.current['engineId'],
            watchedParametersRef.current['salesVersionId'],
            watchedParametersRef.current['gearboxId']
          );

          setGeneratedValues({
            derivativeCode: derivativeCode,
            fullDescription: fullDescription
          });
        }
      });
    }
  }, [mounted]);

  // JSX
  return (
    <DetailContext.Provider
      value={{
        typeOfData: 'data-type',
        title: 'Vehicle',
        // Static
        itemId,
        isNewItem,
        endpoint,
        baseUrl,
        getDetailId,
        getInputs,
        generatedValues,
        // Dynamic
        cultures,
        saveCulturesDataSource,
        saveCultures
      }}>
      <Wrapper />
    </DetailContext.Provider>
  );
}
